// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FlSK","left":"styles_left__27A3P"};